window.gtag = function () {

};
(function ($) {

  // ---------- APP START
  var App = {
    gtag: function (action, params) {
      gtag(
        'event',
        action,
        params
      );
    },
    onPlayVideo: function () {
      $('section.video').each(function () {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          $(this).find('.video__mask').on('click', function () {
            App.gtag(
              'Video-play', {
                'event_category': 'video',
                'event_label': $(this).closest('.video').find('iframe').attr('src')
              }
            );
          });
        }
      });
    },
    planMarquageForm: function () {
      $(document).on('nfFormSubmitResponse', function (event, response) {
        console.log(response);
        if (response.response.errors.length == 0) {
          if (response.id == '4') {
            App.gtag(
              'formulaire-dossier-thematique', {
                'event_category': 'formulaire',
                'event_label': window.location.pathname
              }
            );
          } else if (response.id == '3') {
            App.gtag(
              'formulaire-RH-candidature-spontanee', {
                'event_category': 'formulaire',
                'event_label': (window.location.pathname == '/nous-rejoindre/') ? 'formulaire-RH-candidature-spontanee-OK' : window.location.pathname
              }
            );
          } else if (response.id == '2') {
            App.gtag(
              'inscription-NL', {
                'event_category': 'formulaire',
                'event_label': 'inscription-NL-OK'
              }
            );
          } else if (response.id == '1') {
            App.gtag(
              'formulaire-contact-' + response.response.data.fields[24].value, {
                'event_category': 'formulaire',
                'event_label': 'formulaire-contact-generique-OK'
              }
            );
          }
        }
      });
    },
    clicPdf: function () {
      $('a').each(
        function () {
          var href = $(this).attr('href');
          if ($(this).data('gtag-init') == undefined && (href.substr(-4) == '.pdf' || $(this).attr('download') != undefined)) {
            $(this).data('gtag-init', 1);
            $(this).on('click', function () {
              App.gtag(
                'telechargements-PDF', {
                  'event_category': 'telechargements',
                  'event_label': $(this).attr('href')
                }
              );
            });
          }
        }
      );
    },
    ClickLinkOut: function () {
      $('a').each(function () {
        var href = $(this).attr('href');
        var firstLetter = href[0];
        var letters = ['/', '#'];
        if ($(this).data('gtag-init') == undefined && href.indexOf(window.location.host) == -1 && $.inArray(firstLetter, letters) == -1) {
          $(this).data('gtag-init', 1);
          $(this).on('click', function () {
            App.gtag(
              'liens_sortants', {
                'event_category': 'clics-liens-sortants',
                'event_label': $(this).attr('href')
              }
            );
          });
        }
      });
    },
    ClicZoneMatching: function () {
      if (window.location.pathname == '/start-up/investir-dans-une-start-up/') {
        $('.txt-img__text a.btn, .txt-img-round__text a.btn').each(function () {
          if ($(this).data('gtag-init') == undefined) {
            $(this).data('gtag-init', 1);
            $(this).on('click', function () {
              App.gtag(
                'clic-CTA-investir-start-up', {
                  'event_category': 'clic-CTA',
                  'event_label': $(this).attr('href')
                }
              );
            });
          }
        });
      }
    },
    BtnManifestationInteret: function () {
      if (window.location.pathname.indexOf('nos-appels-a-manifestation-d-interet') != -1) {
        $('.btn_manifestationinteret').each(function () {
          if ($(this).data('gtag-init') == undefined) {
            $(this).data('gtag-init', 1);
            $(this).on('click', function () {
              App.gtag(
                'clic-CTA-manifestation-interet', {
                  'event_category': 'clic-CTA',
                  'event_label': $(this).attr('href')
                }
              );
            });
          }
        });
      }
    },
    EventsAgenda: function () {
      $("section.events a").each(function () {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          $(this).on('click', function () {
            var name = $(this).data('event-name');
            App.gtag(
              'clic-CTA-agenda-en-savoir-plus', {
                'event_category': 'clilc-CTA',
                'event_label': name
              }
            );
          });
        }
      });
    },
    clicCTADepotBrevet: function () {
      if (window.location.pathname == '/laboratoires/proteger-vos-travaux-de-recherche/' && $(".cta-arrow__content").length) {
        $(".cta-arrow__content>.cta-arrow__link").each(function () {
          if ($(this).data('gtag-init') == undefined) {
            $(this).data('gtag-init', 1);
            $(this).on('click', function (event) {
              var mail = $(this).attr('href').replace('mailto:', '');
              App.gtag(
                'clic-CTA-depot-de-brevet', {
                  'event_category': 'clic-CTA',
                  'event_label': mail
                }
              );
            });
          }
        });
      }
    },
    clicCtaDemandeContrat: function () {
      if (window.location.pathname == '/laboratoires/collaborer-avec-une-entreprise/' && $(".cta-arrow__content").length) {
        $(".cta-arrow__content>.cta-arrow__link").each(function () {
          if ($(this).data('gtag-init') == undefined) {
            $(this).data('gtag-init', 1);
            $(this).on('click', function () {
              var mail = $(this).attr('href').replace('mailto:', '');
              App.gtag(
                'clic-CTA-demande-de-contrat', {
                'event_category': 'clic-CTA',
                'event_label': mail
              }
              );
            });
          }
        });
      }
    },
    clickPlugInLabsOuest: function () {
      $('.cta-arrow__link').each(function () {
        if ($(this).data('gtag-init') == undefined && $(this).attr('href') == 'https://www.pluginlabs-ouest.fr/fr') {
          $(this).data('gtag-init', 1);
          $(this).on('click', function () {
            App.gtag(
              'clic-CTA-PILO', {
                'event_category': 'clic-CTA-PILO',
                'event_label': $(this).attr('href')
              }
            );
          });
        }
      });
    },
    ContactFooter: function () {
      $(".cta-contact-footer").each(function () {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          $(this).on('click', function () {
            App.gtag(
              'clic-CTA-contact-footer', {
                'event_category': 'clic-CTA',
                'event_label': 'CTA-contact-footer'
              }
            );
          });
        }
      });
    },
    ImageFooter: function () {
      $("[data-gtag-footerimage]").each(function () {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          $(this).on('click', function () {
            var url = $(this).attr('href');
            App.gtag(
              'liens-sortants', {
                'event_category': 'clics-footer',
                'event_label': url
              }
            );
          });
        }
      });
    },
    EquipeMarquage: function () {
      $('[data-gtag-equipe-name]').each(function () {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          $(this).on('click', function () {
            var name = $(this).data('gtag-equipe-name');
            var category = $(this).data('gtag-equipe-category');
            App.gtag(
              'clic-contact-equipe-' + category, {
                'event_category': 'clic-contact-equipe',
                'event_label': 'clic-contact-' + name
              }
            );
          });
        }
      });
    },
    HeaderPlanMarquage: function () {
      $('.header__social a').each(function (i) {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          var label = '';
          if (i == 0) {
            label = 'LinkedIn';
          } else if (i == 1) {
            label = 'Twitter';
          } else if (i == 2) {
            label = 'Vimeo';
          }
          $(this).on('click', function () {
            App.gtag(
              'clics-header-home', {
                'event_category': 'clics-pictos-RS',
                'event_label': label
              }
            );
          });
        }
      });
    },
    FooterPlanMarquage: function () {
      $('.footer__social a').each(function (i) {
        if ($(this).data('gtag-init') == undefined) {
          $(this).data('gtag-init', 1);
          var label = '';
          if (i == 0) {
            label = 'LinkedIn';
          } else if (i == 1) {
            label = 'Twitter';
          } else if (i == 2) {
            label = 'Vimeo';
          }
          $(this).on('click', function () {
            App.gtag(
              'clics-footer', {
                'event_category': 'clics-pictos-RS',
                'event_label': label
              }
            );
          });
        }
      });
    },
    clicStartup: function () {
      if (window.location.pathname.indexOf('start-up/nos-start-up') != -1) {
        $('.btnstartup, .btn_manifestationinteret').each(function () {
          if ($(this).data('gtag-init') == undefined) {
            $(this).data('gtag-init', 1);
            $(this).on('click', function () {
              App.gtag(
                'liens-sortants-start-up', {
                  'event_category': 'clics-liens-sortants-start-up',
                  'event_label': $(this).attr('href')
                }
              );
            });
          }
        });
      }
    },
    PlanMarquage: function () {
      App.planMarquageForm();
      App.clicPdf();
      App.clicStartup();
      App.ClicZoneMatching();
      App.BtnManifestationInteret();
      App.EventsAgenda();
      App.clicCtaDemandeContrat();
      App.clicCTADepotBrevet();
      App.clickPlugInLabsOuest();
      App.ContactFooter();
      App.ImageFooter();
      App.EquipeMarquage();
      App.HeaderPlanMarquage();
      App.FooterPlanMarquage();
      App.onPlayVideo();
      // Cette méthode doit obligatoirement être en dernière
      App.ClickLinkOut();
    },

    Tac: function () {
      tarteaucitronForceCDN = '/wp-content/themes/crcbn/assets/tac/';

      // Include TAC script
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = tarteaucitronForceCDN + 'tarteaucitron.js';
      $('head').append(s);

      window.tarteaucitronForceLanguage = $('html').attr('lang');
      tarteaucitron.init({
        "hashtag": "#tac",
        "highPrivacy": false,
        "orientation": "bottom",
        "adblocker": false,
        "showAlertSmall": true,
        "cookieslist": true,
        "removeCredit": true
      });
    },

    config: {
      scrollOffset: 90
    },

    init: function () {
      App.PlanMarquage();
      // Init SVG polyfill
      if (typeof (svg4everybody) !== 'undefined') svg4everybody();

      // Init object-fill polyfill
      if (typeof (objectFitImages) !== 'undefined') objectFitImages();

      // Remove focus state when clicking on a button with a mouse
      $(':not(form) button, a').on('click', function (e) {
        if (e.clientX && e.clientY)
          $(this).blur();
      });

      $('a[href^="#"]').on('click', function (e) {
        if ($(this).attr('href') != '#rgpd') {
          e.preventDefault();

          var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');

          if ($(scrollTo).length > 0 && $(this).data('prevent-scroll') !== true){
            App.scroll(scrollTo, $(this).data('scroll-offset'));
          }
        }
      });

      if ($('[data-scroll]').length) {
        App.scroll($('[data-scroll]').data('scroll'));
      }
      $('.content-wall').masonry({
        percentPosition: true,
        columnWidth: '.content-wall__sizer',
        itemSelector: '.content-wall__card',
        gutter: 10,
        horizontalOrder: true
      });
    },

    load: function () {

    },

    // Make div (with eventually child links) clickable
    initClickableDivs: function (context) {
      var clickableDivs;

      if (context === undefined) {
        clickableDivs = $('[data-href]');
      } else if (context.data('href')) {
        clickableDivs = context;
      } else {
        clickableDivs = context.find('[data-href]');
      }

      var enable = true;

      clickableDivs.click(function () {
        if (enable) {
          if ($(this).data('href-target') == '_blank') {
            window.open($(this).data('href'), '_blank');
          } else {
            document.location.href = $(this).data('href');
          }
        }
      }).find('a').click(function (e) {
        if (enable) {
          e.stopPropagation();
        }
      });
    },

    scroll: function (element, offset) {
      offset = offset === undefined ? App.config.scrollOffset : offset;

      $('html, body').animate({
        scrollTop: $(element).offset().top - offset
      }, 'slow');
    },

  };
  // ---------- APP END

  // Init app
  $(document).ready(App.init);
  // $(window).load(App.load); // jQuery 2
  $(window).on('load', App.load); // jQuery 3
  window.App = App;

})(jQuery);
